import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { DICTS, LANGS } from "./strings";

const I18nCtx = createContext(null);
const KEY = "voci-oltre-lang";

const detect = () => {
  const saved = localStorage.getItem(KEY);
  if (saved && DICTS[saved]) return saved;
  const nav = (navigator.language || "it").slice(0, 2);
  return DICTS[nav] ? nav : "it";
};

const fill = (s, vars) => Object.entries(vars || {}).reduce((acc, [k, v]) => acc.replaceAll(`{${k}}`, v), s);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);
  const setLang = useCallback((l) => {
    localStorage.setItem(KEY, l);
    document.documentElement.lang = l;
    setLangState(l);
  }, []);
  const value = useMemo(() => {
    const meta = LANGS.find((l) => l.code === lang);
    const t = (key, vars) => fill(DICTS[lang][key] ?? DICTS.it[key] ?? key, vars);
    const date = (v) => new Date(v).toLocaleDateString(meta.locale);
    return { lang, setLang, t, date, meta };
  }, [lang, setLang]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
